import { RecordingStateType, RootState } from "shared/types";

export const selectRecordingSessionId = () => (state: RootState) =>
  state.classroom.client.recording_session_id;

export const selectRecordingState = () => (state: RootState) =>
  state.classroom.client.recording_state;

export const selectRecordingIsPreparing = () => (state: RootState) =>
  state.classroom.client.recording_state === RecordingStateType.Preparing ||
  state.classroom.client.recording_state === RecordingStateType.Starting;
